import React from 'react';

/**
 * Formats a number with 2 decimal places and thousand separators
 * @param {Object} props - Component props
 * @param {number|string} props.value - The number to format
 * @param {string} props.suffix - Optional suffix to append (e.g., 'USDT')
 * @param {string} props.className - Optional CSS class
 */
const FormattedNumber = ({ value, suffix, className, decimalPlaces = 2, space = true }) => {
  // Parse the value to a number and handle potential NaN
  const numValue = parseFloat(value);
  
  if (isNaN(numValue)) {
    return <span className={className}>0{suffix ? ` ${suffix}` : ''}</span>;
  }
  
  // Format the number with 2 decimal places and thousand separators
  const formattedValue = numValue.toFixed(decimalPlaces || 2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, space ? ' ' : '');
  
  return (
    <span className={className}>
      {formattedValue}{suffix ? ` ${suffix}` : ''}
    </span>
  );
};

export default FormattedNumber; 